import ReactDOM from 'react-dom'
import './index.css'
import React from 'react'
import Routes from './routes'

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);
